// Translate standard identifiers only. Notifications without an official
// English title retain their Thai wording, as specified in the reference.
export function sdocStandardLabel(value, language) {
	if (language !== 'en' || !value) return value
	return value.replace(/(?:มาตรฐานทางเทคนิค\s*)?(กสทช\.|กทช\.)\s*มท\.?\s*([0-9๐-๙]+\s*[-–]\s*[0-9๐-๙]+)/g,
		(_, agency, number) => `${agency === 'กทช.' ? 'NTC' : 'NBTC'} TS. ${number.replace(/[๐-๙]/g, digit => '๐๑๒๓๔๕๖๗๘๙'.indexOf(digit)).replace(/\s/g, '').replace('–', '-')}`)
}
